<template>
  <div class="box">
    <div class="form">
      <!-- <banner></banner> -->
      <div class="title">{{ $t('survey.description') }}</div>
      <div>
        <el-form :model="formInline.form" label-position="top" class="form">
          <el-form-item 
            v-for="(item,index) in formInline" 
            :key="index"
            :label="item.question.name"
            :ref="item.question.code"
          >
            <div v-for="(i,j) in item.answers" :key="j">
              <div v-if="i.subtitle" style="color: #606266;"><strong>{{index+1}}.{{j+1}} {{ i.subtitle.name }}</strong></div>
              <el-row>
                <template v-if="item.multipleChoice">
                  <el-checkbox-group v-model="subform[item.question.code].value">
                    <el-col v-for="(o,k) in i.answers" :key="k" :span="12">
                      <el-checkbox :label="o.code">{{ o.name }}</el-checkbox>
                    </el-col>
                  </el-checkbox-group>
                </template>
                <template v-else>
                    <el-radio-group v-model="subform[item.question.code].value[0]">
                      <el-col :span="12" v-for="(o,k) in i.answers" :key="k" style="margin-bottom: 10px;">
                        <el-radio :label="o.code" >{{ o.name }}</el-radio>
                      </el-col>
                    </el-radio-group>
                </template>
              </el-row>
            </div>
            <!-- <div v-if="item.other.name" style="color: #606266;">
              <div >{{ item.other.name }}</div>
              <el-input size="small" v-model="subform[item.question.code].other.value"></el-input>
            </div> -->
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">{{ $t('survey.btn') }}</el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { questionnaire,getSurvey } from '@/tools/api'
import banner from '@/components/banner.vue'
export default {
  name: 'survey',
  components: {
    banner
  },
  data() {
    return {
      formInline: {},
      props: { multiple: true },
      checkList: [],
      subform: {},
      id: ''
    }
  },
  mounted() {
    // this.formInline = JSON.parse(JSON.stringify(this.$t('survey')))
    let id = sessionStorage.getItem('id')
    if (id) {
      this.id = id
    } else {
      this.$message.error(this.$t('realNameAuthentication.msg1'))
      sessionStorage.clear()
      setTimeout(() => {
        this.$router.replace({ path: '/index' })
      }, 3000)
    }
    this.getSurvey()
  },
  methods: {
    getSurvey() {
      getSurvey().then(res=>{
        this.formInline = res.data.list
        let form = {}
        res.data.list.map(item=>{
          form[item.question.code] = {
            value: [],
          }
        })
        this.subform = form
      })
    },
    onSubmit() {

      let obj = JSON.parse(JSON.stringify(this.subform))
      console.log(obj)
      let isPass = true
      for (let key in obj) {
        if (obj[key].value.length < 1) {
          isPass = false
          this.$message.error(this.$t('message.survertip'))
          this.$nextTick(() => {
            let dom = this.$refs[key][0].$el
            dom.scrollIntoView({ behavior: 'smooth', block: 'start' })
          })
          break
        }
      }
      if (isPass) {
        let formData = new FormData()
        formData.append("id", this.id)
        formData.append("content", JSON.stringify(this.transformData(obj)))
        questionnaire(formData).then(res => {
          if (res.code == 0) {
            sessionStorage.setItem('id', res.data.id)
            let path
            if (res.data.step == 5) {
              path = '/confirmationLetter'
            }
            if (res.data.step == 4) {
              path = '/payment'
            }
            this.$router.replace({ path })
          } else {
            this.$message.error(res.msg)
          }
        })
      }

    },
    transformData(data) {
      const result = [];
      for (const [key, obj] of Object.entries(data)) {
        const values = [...obj.value];
        // if (obj.other.key && obj.other.value) {
        //   values.push(`${obj.other.key}:${obj.other.value}`);
        // }
        result.push({ [key]: values.length > 0 ? values.join(',') : '' });
      }
      return result;
    }
  }
}
</script>


<style scoped>
.form /deep/ .el-form-item__label {
  font-size: 16px;
  font-weight: bold;
}

.form /deep/ .el-checkbox__label {
  min-width: 200px;
  white-space: normal;
}

.form .el-checkbox {
  display: flex;
  margin-bottom: 10px;
}
</style>